<template>
<div class="compounds-main" v-loading="loading" :element-loading-text="loadingText">
  <modal v-model="targetsVisible" v-if="compoundToShow">
    <div style="width:800px;height:600px;overflow-y:auto;padding:20px">
      <el-row class="result-target result-targets-head">
        <el-col :span="4" class="result-target-id">Target ID</el-col>
        <el-col :span="4" class="result-target-name">Target Name</el-col>
        <el-col :span="4" class="result-target-organism">Species</el-col>
        <el-col :span="3" class="result-target-activity">Activity</el-col>
        <el-col :span="4" class="result-target-activity-type">Activity Type</el-col>
        <el-col :span="4" class="result-target-assay">Assay</el-col>
      </el-row>

      <el-row class="result-target" v-for="(target, j) in compoundToShow.targets" :key="j">
        <el-col :span="4" class="result-target-id"><a target="_blank" :href="targetLink(compoundToShow.database, target.id)">{{target.id}}</a>&nbsp;</el-col>
        <el-col :span="4" class="result-target-name">{{target.pref_name}}&nbsp;</el-col>
        <el-col :span="4" class="result-target-organism">{{target.organism}}&nbsp;</el-col>
        <el-col :span="3" class="result-target-activity">{{parseFloat(target.act_value).toFixed(2)}} {{target.act_units}}&nbsp;</el-col>
        <el-col :span="4" class="result-target-activity-type">{{target.act_type}}&nbsp;</el-col>
        <el-col :span="4" class="result-target-assay"><a target="_blank" :href="assay_link(compoundToShow.database, target.assay_id)">{{target.assay_id}}</a>&nbsp;</el-col>
      </el-row>
    </div>
  </modal>

  <!-- CHEMBL Results Body -->
  <div class="results-body">
    <div style="margin:10px 0px">
      <el-pagination background layout="prev, pager, next" :page-size="$store.state.itemsPerPage" :current-page="page" :total="compoundIds.length" @current-change="page=$event"></el-pagination>
    </div>

    <div class="shaded-box" style="font-size:12px" v-for="(id, i) in sortedCompoundIds" :key="i">
      <div class="padded-box" style="display:flex;flex-direction:row;">
        <div style="flex:1 1">
          <div style="height:30px;line-height:30px" class="info-row">
            <span style="font-size:20px;font-weight:550"><a target="_blank" :href="compLink(compound(id).database, compound(id).id)">{{compound(id).id}}</a></span>
          </div>

          <div v-if="compound(id).synonyms" class="info-row">
            <b>Name</b>: {{compound(id).synonyms}}
          </div>

          <div class="info-row" style="display:flex;flex-direction:row;align-items:center">
            <div style="margin-right:10px"><b>FP2 Similarity</b>:</div> <div style="width:80px;margin-right:10px"><el-progress :stroke-width="5" :color="'#46c8c8'" :show-text="false" :percentage="compound(id).fp2score*100"></el-progress></div><div>{{toFixed(compound(id).fp2score, 2)}}</div>
          </div>

          <div class="info-row" style="display:flex;flex-direction:row;align-items:center">
            <div style="margin-right:10px"><b>Pharmacophore Similarity</b>:</div> <div style="width:80px;margin-right:10px"><el-progress :stroke-width="5" :color="'#e6a23c'" :show-text="false" :percentage="compound(id).pharmscore*100"></el-progress></div><div>{{toFixed(compound(id).pharmscore, 2)}}</div>
          </div>

          <div class="info-row">
            <b>Molecular Weight</b>: {{compound(id).mw}}
          </div>

          <div v-if="compound(id).formula" class="info-row">
            <b>Formula</b>: {{compound(id).formula}}
          </div>

          <div class="info-row"><b>Associated Targets ({{$store.getters.compoundTargets[id].length}})</b>:</div>

          <div class="info-row button-group-container">
            <button-group :data="compoundTargets[id].map(targetid => { let target = targets[targetid]; return { name: target.pref_name, link: targetLink(compound.db, targetid) } })"></button-group>
          </div>

          <!-- <el-row class="result-target-functions">
            <el-col :md="4" :lg="3" class="result-target-functions-label">
              <b>Functions</b>:
            </el-col>

            <el-col :md="21" :lg="22" class="result-target-functions-right">
              <button-group :data="chemblFunctions[i].map(func => { return { name: `${func.name} (${func.functions.length})`, link: `https://www.ebi.ac.uk/QuickGO/GTerm?id=${func.functions[0].id}` } })"></button-group>
            </el-col>
          </el-row>

          <el-row class="result-target-processes">
            <el-col :md="4" :lg="3" class="result-target-processes-label">
              <b>Processes</b>:
            </el-col>

            <el-col :md="21" :lg="22" class="result-target-processes-right">
              <button-group :data="targetProcesses[i].map(proc => { return { name: `${proc.name} (${proc.processes.length})`, link: `https://www.ebi.ac.uk/QuickGO/GTerm?id=${proc.processes[0].id}` } })"></button-group>
            </el-col>
          </el-row>
 -->
        </div>

        <div style="flex:0 0 200px">
          <div class="compound-img-wrapper">
            <!-- <img v-if="compound(id).database==='CHEMBL'" :src="`https://www.ebi.ac.uk/chembl/api/data/image/${compound(id).id}.svg?engine=indigo`" height="200px" width="200px"> -->
            <img :src="smilesLink(compound(id).smiles)" width="150px">
            <!-- <div class="compound-img-cover">
              <div @click="resultToCompare=v;compareVisible=true" class="compound-img-cover-button">
                Compare
              </div>
            </div> -->
          </div>
        </div>

      </div>

      <!-- <div style="border-top:1px solid #eeeeee;padding-top:5px;padding-bottom:5px" class="padded-box" v-if="v.targets.length>0">
        <span class="theme-text" style="cursor:pointer" @click="compoundToShow=v;targetsVisible=true">Targets</span>
      </div> -->
    </div>

    <div style="margin:10px 0px">
      <el-pagination background layout="prev, pager, next" :page-size="$store.state.itemsPerPage" :current-page="page" :total="compoundIds.length" @current-change="page=$event"></el-pagination>
    </div>
  </div> <!-- CHEMBL Results Body -->

  <div style="flex:0 0 300px;margin-left:15px;margin-top:20px;">
    <div style="position:sticky;top:10px">
      <!-- <div class="results-menu-filters" @click="filtersVisible=true"><i class="el-icon-edit-outline"></i> Filters</div> -->

      <!-- Number of results -->
      <div style="margin-bottom:20px"><b v-text="Object.keys(compounds).length"></b> Compounds</div>

      <div class="results-menu-sort">
        <!-- <div @click="sortOptions=getCurrentRef().getSortTokens();sortMenuVisible=true"><i class="el-icon-sort"></i> Sort</div> -->
        <div @click="sortMenuVisible=true"><i class="el-icon-sort"></i> Sort</div>

        <!-- Sort Menu -->
        <div class="popup-menu" v-if="sortMenuVisible">
          <div class="popup-menu-head">
            <div class="popup-menu-title">CHOOSE SORT OPTIONS</div>
            <div class="popup-menu-close" @click="sortMenuVisible=false"><i class="el-icon-close"></i></div>
          </div>
          <div class="popup-menu-body">
            <div class="popup-menu-item" @click="sortMenuVisible=false;sortCompounds('name')">
              <span>Name</span>
            </div>
            <div class="popup-menu-item" @click="sortMenuVisible=false;sortCompounds('fp2')">
              <span>FP2 Similarity</span>
            </div>
            <div class="popup-menu-item" @click="sortMenuVisible=false;sortCompounds('pharmacophore')">
              <span>Pharmacophore Similarity</span>
            </div>
            <div class="popup-menu-item" @click="sortMenuVisible=false;sortCompounds('weight')">
              <span>Molecular Weight</span>
            </div>
            <div class="popup-menu-item" @click="sortMenuVisible=false;sortCompounds('ntargets')">
              <span>Number of Targets</span>
            </div>
          </div>
        </div>
      </div>

      <div class="results-menu-download">
        <div class="popup-menu-button" @click="downloadMenuVisible=true"><i class="el-icon-download"></i> Download</div>

        <!-- Download Menu -->
        <div class="popup-menu" v-if="downloadMenuVisible">
          <div class="popup-menu-head">
            <div class="popup-menu-title">DOWNLOAD</div>
            <div class="popup-menu-close" @click="downloadMenuVisible=false"><i class="el-icon-close"></i></div>
          </div>
          <div class="popup-menu-body">
            <div class="popup-menu-item" @click="saveCompounds();downloadMenuVisible=false">
              Identified Compounds for the Current Query Compound (csv)
            </div>
            <div class="popup-menu-item" @click="saveAllCompounds();downloadMenuVisible=false">
              Identified Compounds for All Query Compounds (csv)
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <el-dialog :visible.sync="compareVisible" width="500px" v-if="resultToCompare">
    <div class="compare-compound-row">
      <div class="compare-compound-left">Query</div>
      <div class="compare-compound-right"><a target="_blank" :href="compLink(resultToCompare.database, resultToCompare.id)">{{resultToCompare.id}}</a></div>
    </div>

    <div class="compare-compound-row">
      <div class="compare-compound-left">
        <img :src="smilesLink($store.state.getters.compoundSmiles[$store.state.route.params.icompound])">
      </div>
      <div class="compare-compound-right">
        <img v-if="resultToCompare.database==='CHEMBL'" :src="`https://www.ebi.ac.uk/chembl/api/data/image/${resultToCompare.id}.svg?engine=indigo`">
        <img v-if="resultToCompare.database==='Metabolites'" :src="smilesLink(resultToCompare.smiles)">
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="compareVisible = false">Cancel</el-button>
      <el-button type="primary" @click="compareVisible = false">Confirm</el-button>
    </span>
  </el-dialog>

</div>
</template>

<script>
import { bus } from '../bus.js'
import utils from '../utils.js'
// import axios from 'axios'
import html2pdf from 'html2pdf.js'
import jsonexport from 'jsonexport/dist'
import ButtonGroup from './ButtonGroup.vue'
import Vuex from 'vuex'
import makeTaskStore from '../store/task-store.js'

export default {
  name: 'Compounds',

  data () {
    return {
      task: '',
      sortMenuVisible: false,
      downloadMenuVisible: false,
      sortDirection: 1,

      compareVisible: false,
      resultToCompare: '',
      compoundToShow: '',
      targetsVisible: false,

      page: 1,
      sortBy: 'pharmacophore',

      loading: false,
      loadingText: ''
    }
  },

  components: {
    ButtonGroup
  },

  computed: {
    ...Vuex.mapGetters([
      'assays',
      'targets',
      'compounds',
      'compoundTargets',
      'compoundIds'
    ]),

    sortedCompoundIds () {
      let ids = [...this.compoundIds]
      let n = this.$store.state.itemsPerPage
      let compounds = this.$store.getters.compounds
      let compoundTargets = this.$store.getters.compoundTargets
      if (this.sortBy === 'fp2') {
        ids.sort((a, b) => (compounds[b].fp2score - compounds[a].fp2score) * this.sortDirection)
      } else if (this.sortBy === 'pharmacophore') {
        ids.sort((a, b) => (compounds[b].pharmscore - compounds[a].pharmscore) * this.sortDirection)
      } else if (this.sortBy === 'weight') {
        ids.sort((a, b) => (compounds[b].mw - compounds[a].mw) * this.sortDirection)
      } else if (this.sortBy === 'ntargets') {
        ids.sort((a, b) => (compoundTargets[b].length - compoundTargets[a].length) * this.sortDirection)
      } else if (this.sortBy === 'name') {
        ids.sort((a, b) => this.safeLocaleCompareStringArray(compoundTargets[a].synonyms, compoundTargets[b].synonyms) * this.sortDirection)
      }

      return ids.slice((this.page - 1) * n, this.page * n)
    },

    ncompounds () {
      let smi = this.$store.getters.par.compound
      if (smi) {
        return smi.split('\n').filter(line => line.trim() !== '').length
      } else {
        return 0
      }
    }
  },

  methods: {
    ...utils.mapUtils([
      'targetLink',
      'compLink',
      'smilesLink',
      'assayLink',
      'databaseLink',
      'redirect',
      'openNewTab',
      'safeLocaleCompareStringArray',
      'saveCsv',
      'download',
      'toFixed'
    ]),

    compound (compoundid) {
      return this.$store.getters.compounds[compoundid]
    },

    sortCompounds (by) {
      this.sortBy = by
      this.sortDirection *= -1
    },

    compoundLines (store, icompound) {
      let content = ''
      for (let compoundid in store.getters.compounds) {
        let compound = store.getters.compounds[compoundid]
        content += `${parseInt(icompound) + 1},${compoundid},${compound.smiles},${compound.fp2score},${compound.pharmscore}\n`
      }
      return content
    },

    saveCompounds () {
      let content = 'Query Compound,Compound,Compound SMILES,FP2 Similarity, Pharmacophore Similarity\n'
      content += this.compoundLines(this.$store, this.$store.state.route.params.icompound)
      this.download(content, `Drift-${this.$store.state.route.params.id}-${this.$store.state.route.params.icompound + 1}-compounds.csv`)
    },

    async saveAllCompounds () {
      this.loading = true
      let store = new Vuex.Store(makeTaskStore())
      let r = {}
      for (let k of ['minimalCompoundSimilarity', 'hideNullCompounds', 'hideOwnTargets', 'targetTypes', 'targetSpecies', 'assayRange']) {
        r[k] = this.$store.state[k]
      }
      store.commit('set', r)

      let taskid = this.$store.state.route.params.id
      let content = 'Query Compound,Compound,Compound SMILES,FP2 Similarity, Pharmacophore Similarity\n'
      for (let icompound = 0; icompound < this.ncompounds; icompound++) {
        this.loadingText = `Downloading Compounds for Query Compound ${icompound + 1}`
        await store.dispatch('fetchTask', {taskid, icompound})
        content += this.compoundLines(store, icompound)
      }
      this.download(content, `Drift-${this.$store.state.route.params.id}-compounds.csv`)
      this.loading = false
    }
  },

  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";


.compounds-main {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
}

.results-body {
  flex: 1 1;
}

.result-row {
  /*
  border: 1px solid lighten($font-grey, 50%);
  */
  border-radius: 4px;
  margin-bottom: 20px;
}

.compound-card-head {
  height: 30px;
  line-height: 30px;
  /*
  border-bottom: 1px solid lighten($font-grey, 50%);
  */
  padding: 0px 5px 0px 20px;
  font-weight: 600;
}

.compound-card-body {
  padding: 20px;
}

.result-row-left {
  padding-bottom: 20px;
}

.result-row-right {
}

.result-row-right >div {
  margin-bottom: 10px;
}

.result-id {
}

.result-score {
}

.results-head .result-score {
  cursor: pointer;
}

.result-mw {
}

.results-head .result-mw {
  cursor: pointer;
}

.result-formula {
}

.result-targets {
}

.result-targets-left {
}

.result-targets-right {
  font-size: 14px;
  max-height: 200px;
  overflow-y: auto;
}

.result-target {
  padding: 0px 0px;
}

.result-target >div {
  padding: 5px 0px;
  word-wrap:break-word;
}

.result-target-id {
  text-align: left;
}

.result-target-name {
  text-align: left;
}

.result-target-activity {
  text-align: left;
}

.result-target-activity-type {
  text-align: left;
}

.result-target-units {
  text-align: left;
}

.result-target-assay {
  text-align: left;
}

.compound-img-wrapper {
  position: relative;
  text-align: center;
}

.compound-img-cover {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: none;
  flex-direction: row;
  align-items: center;
  text-align: center;
}

.compound-img-wrapper:hover .compound-img-cover {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.compound-img-cover-button {
  border: 1px solid $theme-color-light;
  color: $theme-color-light;
  margin: auto auto;
  padding: 5px;
  cursor: pointer;
  font-weight: bold;
}

.compare-compound-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
}

.compare-compound-left {
  width: 250px;
}

.compare-compound-left img {
  width: 100%;
}

.compare-compound-right {
  width: 250px;
}

.compare-compound-right img {
  width: 100%;
}

.result-row .result-id a:hover {
  text-decoration: underline;
  color: $theme-color;
}

.result-target.result-targets-head {
  font-weight: 500;
}

.info-row {
  margin: 10px 0px;
}

</style>
